var _style, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag4De({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDCC00;}\n\t.st1{fill:#DD0000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy_1_",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8C2.6,42,0,39.4,0,36.3 V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,36.3C0,39.4,2.6,42,5.8,42h52.4c3.2,0,5.8-2.5,5.8-5.7V14H0V36.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    className: "st1",
    width: 64,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag4De);
export default __webpack_public_path__ + "static/media/flag_4_DE.951b73fa60d15d73c6985678077cc963.svg";
export { ForwardRef as ReactComponent };